import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { FC } from 'react';
import { IMappingFormSettingsResponse } from 'wisestep-api';

import ISubmissionSettingContext from '../../types/ISubmissionSettingContext';
import ISubmissionSettingsResponse from '../../types/ISubmissionSettingsResponse';
import { Item } from '../Item';
import { Label } from '../Label';
import { WsLocationSearch } from '../WsLocationSearch';
import { WsTypoColors, WsTypography, WsTypoVariants } from '../WsTypography';

const GridItem = styled(Item)(() => ({
  paddingTop: 0,
  paddingBottom: '10px',
}));

interface ILocationInfo {
  submissionSetting?: ISubmissionSettingsResponse | ISubmissionSettingContext | null;
  mappingFormSettings?: IMappingFormSettingsResponse;
  purpose?: 'submission' | 'mapping';
  showTitle?: boolean;
}

const LocationInfo: FC<ILocationInfo> = ({
  submissionSetting,
  purpose = 'submission',
  showTitle = true,
  mappingFormSettings,
}) => (
  <>
    {showTitle && (
      <GridItem>
        <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.PRIMARY}>
          Current Location
        </WsTypography>
      </GridItem>
    )}
    {purpose === 'submission' && !submissionSetting?.currentLocation?.hidden && (
      <GridItem>
        <Grid item xs={8.5}>
          <Label>{`Location ${submissionSetting?.currentLocation?.required ? '*' : ''}`}</Label>
          <WsLocationSearch placeHolder="" name="currentLocation" />
        </Grid>
      </GridItem>
    )}
    {purpose === 'mapping' && mappingFormSettings?.locations.show && (
      <GridItem>
        <Label>{`Location ${mappingFormSettings?.locations?.mandatory ? '*' : ''}`}</Label>
        <WsLocationSearch
          placeHolder=""
          name="currentLocation"
          required={mappingFormSettings?.locations.mandatory}
        />
      </GridItem>
    )}
  </>
);

export default LocationInfo;
